import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';
import { CloseIcon } from '@sainsburys-tech/bolt-icons';
import { getAvailability as getAvailabilityAction, getMoreAvailability as getMoreAvailabilityAction } from '../../actions/availability';
import { init as initTrackingAction, clickQuit as clickQuitAction, clickStoreDetails as clickStoreDetailsAction, clickSelectStore as clickSelectStoreAction, clickWantItDelivered as clickWantItDeliveredAction, clickFilter as clickFilterAction, trackSearch as trackSearchAction } from '../../actions/tracking';
import { hasAvailabilityCheck, showMoreAvailability } from '../../helpers/storeHelpers';
import AvailabilityFilters from '../../components/AvailabilityFilters/AvailabilityFilters';
import AvailabilityResults from '../../components/AvailabilityResults/AvailabilityResults';
import ContentPlaceholder from '../../components/ContentPlaceholder/ContentPlaceholder';
import DidYouMean from '../../components/DidYouMean/DidYouMean';
import MoreAvailability from '../../components/MoreAvailability/MoreAvailability';
import Search from '../../components/Search/Search';
import StoreDetails from '../../components/StoreDetails/StoreDetails';
import WantItDelivered from '../../components/WantItDelivered/WantItDelivered';
import * as Styled from './StoreSelector.styles';

var StoreSelector = /*#__PURE__*/function (_Component) {
  _inherits(StoreSelector, _Component);

  var _super = _createSuper(StoreSelector);

  // Filter tab should say tomorrow after 8pm
  function StoreSelector(props) {
    var _this;

    _classCallCheck(this, StoreSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "currentHour", new Date().getHours());

    _defineProperty(_assertThisInitialized(_this), "savePreviousDigitalData", function () {
      if (!window.digitalData || !window.digitalData.page) return;

      var previousPageInfo = _objectSpread({}, window.digitalData.page.pageInfo);

      _this.setState({
        previousPageInfo: previousPageInfo
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resetDigitalData", function () {
      if (!window.digitalData || !window.digitalData.page) return;
      var previousPageInfo = _this.state.previousPageInfo;
      window.digitalData.page.pageInfo = previousPageInfo;

      _this.setState({
        previousPageInfo: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
        _this.onQuit(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setModalInnerRef", function (node) {
      _this.modalInnerRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "searchProductAvailability", function (origin, code) {
      var _this$props = _this.props,
          skuQty = _this$props.product.skuQty,
          config = _this$props.config,
          maxResults = _this$props.maxResults,
          maxDistance = _this$props.maxDistance,
          getAvailability = _this$props.getAvailability;
      getAvailability(config.api.availability, {
        origin: origin,
        skuQty: skuQty,
        maxResults: maxResults,
        maxDistance: maxDistance,
        save: code
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchBasketAvailability", function (origin, code) {
      var _this$props2 = _this.props,
          _this$props2$basket = _this$props2.basket,
          skuQty = _this$props2$basket.skuQty,
          orderId = _this$props2$basket.orderId,
          config = _this$props2.config,
          maxResults = _this$props2.maxResults,
          maxDistance = _this$props2.maxDistance,
          getAvailability = _this$props2.getAvailability;
      getAvailability(config.api.basket, {
        origin: origin,
        skuQty: skuQty,
        orderId: orderId,
        maxResults: maxResults,
        maxDistance: maxDistance,
        save: code
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onViewStoreMap", function (event, store) {
      if (event !== null) event.preventDefault();

      if (_this.state.activeStore === store) {
        _this.setState({
          activeStore: null
        });
      } else {
        _this.props.trackMap(store.id);

        _this.setState({
          activeStore: store
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onQuit", function (event) {
      if (event !== null) event.preventDefault();

      _this.props.trackQuit();

      _this.props.closeStoreSelector(event, null, null, null, _this.state.searchTerm);
    });

    _defineProperty(_assertThisInitialized(_this), "onWantItDelivered", function (event, store, goToDelivery, productSelected) {
      if (event !== null) event.preventDefault();

      _this.props.trackWantItDelivered();

      _this.props.closeStoreSelector(event, store, goToDelivery, productSelected);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (searchTerm) {
      var updateState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var searchBoxWasUsed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var aoSaveParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-ss:/';
      if (updateState) _this.setState({
        searchTerm: searchTerm
      });
      var code = _this.props.config.analytics.code;
      code = "".concat(code).concat(aoSaveParam);

      _this.props.trackSearch(searchTerm, updateState, searchBoxWasUsed);

      if (_this.props.product) _this.searchProductAvailability(searchTerm, code);
      if (_this.props.basket) _this.searchBasketAvailability(searchTerm, code);
    });

    _defineProperty(_assertThisInitialized(_this), "onDidYouMeanSelection", function (event, searchTerm) {
      if (event !== null) event.preventDefault();

      _this.onSearch(searchTerm, false, true, '-ss:cc');
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectThisStore", function (event, store, goToDelivery, productSelected, ctaLocation, aoSaveParam) {
      if (event !== null) event.preventDefault();
      var code = _this.props.config.analytics.code;
      code = "".concat(code).concat(aoSaveParam);

      _this.props.trackSelectStore(store.id, ctaLocation);

      _this.props.closeStoreSelector(event, store, goToDelivery, productSelected, _this.state.searchTerm, code);
    });

    _defineProperty(_assertThisInitialized(_this), "onGetMoreAvailability", function (event) {
      if (event !== null) event.preventDefault();
      var _this$props3 = _this.props,
          config = _this$props3.config,
          getMoreAvailability = _this$props3.getMoreAvailability,
          apiSearchValue = _this$props3.apiSearchValue,
          product = _this$props3.product,
          basket = _this$props3.basket;
      var origin = apiSearchValue;
      var params = {
        origin: origin,
        // eslint-disable-next-line no-nested-ternary
        skuQty: product ? product.skuQty : basket ? basket.skuQty : null,
        orderId: basket && basket.orderId
      };
      getMoreAvailability(config.api.stock, params);
    });

    _defineProperty(_assertThisInitialized(_this), "cutoffHour", 20);

    _defineProperty(_assertThisInitialized(_this), "filters", [{
      label: 'Anytime',
      id: null
    }, {
      label: _this.currentHour >= _this.cutoffHour ? 'Tomorrow' : 'Today',
      id: _this.currentHour >= _this.cutoffHour ? 3 : 2
    }]);

    _defineProperty(_assertThisInitialized(_this), "onToggleFilter", function (tabIndex) {
      var filterObj = _this.filters[tabIndex];

      _this.props.trackFilter(filterObj);

      _this.setState({
        activeFilter: filterObj
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSkuParam", function () {
      var _this$props4 = _this.props,
          product = _this$props4.product,
          basket = _this$props4.basket; // eslint-disable-next-line no-nested-ternary

      return product ? product.skuQty : basket ? basket.skuQty : null;
    });

    _this.state = {
      activeFilter: {
        label: 'Anytime',
        id: null
      },
      activeStore: null,
      previousPageInfo: null,
      searchTerm: _this.props.searchTerm
    };
    var _props$config = props.config,
        analytics = _props$config.analytics,
        stockFinder = _props$config.stockFinder;
    var activeFilter = _this.state.activeFilter;
    if (props.initTracking) props.initTracking(analytics, stockFinder.enabled, activeFilter, _this.getSkuParam());
    return _this;
  }

  _createClass(StoreSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
          storeId = _this$props5.storeId,
          searchTerm = _this$props5.searchTerm;
      this.savePreviousDigitalData();

      if (storeId) {
        this.onSearch("st:".concat(storeId));
      } else {
        this.onSearch(this.state.searchTerm);
      }

      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('touchstart', this.handleClickOutside);
      document.body.style.overflow = 'hidden';
      this.setState({
        searchTerm: searchTerm
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
      document.removeEventListener('touchstart', this.handleClickOutside);
      document.body.style.overflow = 'visible';
      this.resetDigitalData();
      this.setState({
        searchTerm: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          dataTest = _this$props6['data-test'],
          basket = _this$props6.basket,
          config = _this$props6.config,
          ctaAddToTrolley = _this$props6.ctaAddToTrolley,
          error = _this$props6.error,
          loading = _this$props6.loading,
          locations = _this$props6.locations,
          availability = _this$props6.availability,
          stores = _this$props6.stores,
          storeDistances = _this$props6.storeDistances,
          moreAvailability = _this$props6.moreAvailability,
          moreAvailabilityError = _this$props6.moreAvailabilityError,
          moreAvailabilityLoading = _this$props6.moreAvailabilityLoading,
          allResultsOutOfStock = _this$props6.allResultsOutOfStock,
          safeMode = _this$props6.safeMode,
          mapsKey = _this$props6.mapsKey;
      var enableDeliveryButton = config.enableDeliveryButton,
          enableGeoLocation = config.enableGeoLocation,
          stockFinder = config.stockFinder;
      var _this$state = this.state,
          activeFilter = _this$state.activeFilter,
          activeStore = _this$state.activeStore,
          searchTerm = _this$state.searchTerm;
      var skuParam = this.getSkuParam();
      var showMoreAvailabilityFeature = showMoreAvailability(stockFinder.enabled, allResultsOutOfStock, safeMode, skuParam);
      var moreThanOneSku = skuParam && skuParam.split(',') > 1;
      var moreAvailabilityHeading = moreThanOneSku ? 'Good news! Your items are available!' : 'Good news! Your item is available!';
      return /*#__PURE__*/React.createElement("div", {
        "data-test": dataTest
      }, /*#__PURE__*/React.createElement(Styled.StoreSelectorModal, {
        "data-test": "component-store-selector-modal"
      }, /*#__PURE__*/React.createElement(FocusTrap, null, /*#__PURE__*/React.createElement(Styled.ModalContent, {
        ref: this.setWrapperRef,
        "data-test": "component-store-selector-modal-content"
      }, /*#__PURE__*/React.createElement(Styled.ModalHeader, {
        "data-test": "component-store-selector-modal-header"
      }, /*#__PURE__*/React.createElement("h3", null, "Find a collection store"), /*#__PURE__*/React.createElement(Styled.ModalCloseButton, {
        onClick: this.onQuit,
        kind: "secondary",
        iconOnly: true,
        "data-test": "component-store-selector-close-button"
      }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Styled.ModalInner, {
        ref: this.setModalInnerRef,
        "data-test": "component-store-selector-modal-inner"
      }, /*#__PURE__*/React.createElement(Search, {
        searchTerm: searchTerm,
        error: error,
        enableGeoLocation: enableGeoLocation,
        onSearch: this.onSearch,
        searchByGeolocation: this.onSearchByGeolocation,
        label: "Find a store"
      }), locations === null && /*#__PURE__*/React.createElement(AvailabilityFilters, {
        filters: this.filters,
        activeFilter: activeFilter,
        toggleFilter: this.onToggleFilter
      }), locations !== null && /*#__PURE__*/React.createElement(DidYouMean, {
        locations: locations,
        selectStore: this.onDidYouMeanSelection
      }), loading && /*#__PURE__*/React.createElement(Styled.ModalInnerSection, null, /*#__PURE__*/React.createElement(Styled.ContentPlaceholderGroup, null, /*#__PURE__*/React.createElement(ContentPlaceholder, null), /*#__PURE__*/React.createElement(ContentPlaceholder, null), /*#__PURE__*/React.createElement(ContentPlaceholder, null), /*#__PURE__*/React.createElement(ContentPlaceholder, null), /*#__PURE__*/React.createElement(ContentPlaceholder, null))), !loading && availability !== null && stores !== null && /*#__PURE__*/React.createElement(Styled.ModalInnerSection, null, showMoreAvailabilityFeature && /*#__PURE__*/React.createElement(MoreAvailability, {
        availability: moreAvailability,
        showExpand: basket !== null,
        loading: moreAvailabilityLoading,
        error: moreAvailabilityError,
        fetchMoreAvailability: this.onGetMoreAvailability,
        moreAvailabilityHeading: moreAvailabilityHeading,
        toggleActiveStore: this.onViewStoreMap,
        ctaAddToTrolley: ctaAddToTrolley,
        selectStoreCallback: this.onSelectThisStore,
        searchTerm: searchTerm
      }), /*#__PURE__*/React.createElement(AvailabilityResults, {
        availability: availability,
        stores: stores,
        showExpand: basket !== null,
        ctaAddToTrolley: ctaAddToTrolley,
        selectStoreCallback: this.onSelectThisStore,
        toggleActiveStore: this.onViewStoreMap,
        activeFilter: activeFilter,
        showUnavailableMessage: !stockFinder.enabled,
        searchTerm: searchTerm
      }))), enableDeliveryButton && /*#__PURE__*/React.createElement(WantItDelivered, {
        handleClick: this.onWantItDelivered
      }), /*#__PURE__*/React.createElement(StoreDetails, {
        store: activeStore,
        distance: activeStore && storeDistances[activeStore.id],
        toggleActiveStore: this.onViewStoreMap,
        selectStoreCallback: this.onSelectThisStore,
        mapsKey: mapsKey
      }))), /*#__PURE__*/React.createElement(Styled.ModalOverlay, null)));
    }
  }]);

  return StoreSelector;
}(Component);

_defineProperty(StoreSelector, "propTypes", {
  /**
   * Specify an optional data-test attribute to be added to your Button for e2e testing
   */
  'data-test': PropTypes.string,

  /** User supplied props */

  /**
   * Specify search string
   */
  searchTerm: PropTypes.string,

  /**
   * Specify the store ID
   */
  storeId: PropTypes.number,

  /**
   * Specify the maximum number of stores to request
   */
  maxResults: PropTypes.number,

  /**
   * Specify the maximum distance to search for stores
   */
  maxDistance: PropTypes.number,

  /**
   * Specify the product sku and quantity
   */
  product: PropTypes.shape({
    skuQty: PropTypes.string
  }),

  /**
   * Specify the Basket
   */
  basket: PropTypes.shape({
    skuQty: PropTypes.string,
    orderId: PropTypes.string
  }),

  /**
   * Specify the store selector config
   */
  config: PropTypes.shape({
    enableDeliveryButton: PropTypes.bool,
    enableGeoLocation: PropTypes.bool,
    api: PropTypes.shape({
      availability: PropTypes.string,
      stock: PropTypes.string
    }),
    stockFinder: PropTypes.shape({
      enabled: PropTypes.bool
    }),
    analytics: PropTypes.shape({
      section: PropTypes.string,
      code: PropTypes.string
    })
  }),

  /**
   * Add to Trolley function
   */
  ctaAddToTrolley: PropTypes.func,

  /**
   * Close Store Selector function
   */
  closeStoreSelector: PropTypes.func,
  // Redux supplied props
  error: PropTypes.string,
  loading: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    suggestion: PropTypes.string
  })),
  availability: PropTypes.array,
  // see reducer
  stores: PropTypes.object,
  // see reducer
  moreAvailability: PropTypes.array,
  // see reducer
  moreAvailabilityLoading: PropTypes.bool,
  moreAvailabilityError: PropTypes.bool,
  allResultsOutOfStock: PropTypes.bool,
  apiSearchValue: PropTypes.string,
  safeMode: PropTypes.shape({
    stockCheckDisabled: PropTypes.bool
  }),
  mapsKey: PropTypes.string
});

_defineProperty(StoreSelector, "defaultProps", {
  searchTerm: '',
  storeId: null,
  maxResults: 10,
  maxDistance: 50,
  product: null,
  basket: null,
  apiSearchValue: '',
  config: {
    enableDeliveryButton: true,
    enableGeoLocation: false,
    api: {
      availability: '/stores/api/orchestrator/v0/locator/availability',
      basket: '/stores/api/orchestrator/v0/locator/availability/basket',
      stock: '/stores/api/orchestrator/v0/locator/availability/nationwide'
    },
    stockFinder: {
      enabled: false
    },
    analytics: {
      section: 'trolley',
      code: 'tlp'
    }
  },
  ctaAddToTrolley: function ctaAddToTrolley() {},
  closeStoreSelector: function closeStoreSelector() {},
  'data-test': 'component-store-selector'
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    locations: state.storeSelectorAvailability.locations,
    loading: state.storeSelectorAvailability.loading || state.storeSelectorStoreinfo.loading,
    error: state.storeSelectorAvailability.error,
    availability: state.storeSelectorAvailability.availability,
    storeDistances: state.storeSelectorAvailability.distances,
    stores: state.storeSelectorStoreinfo.stores,
    safeMode: state.storeSelectorAvailability.safeMode,
    moreAvailabilityLoading: state.storeSelectorAvailability.moreAvailabilityLoading,
    moreAvailabilityError: state.storeSelectorAvailability.moreAvailabilityError,
    moreAvailability: state.storeSelectorAvailability.moreAvailability,
    allResultsOutOfStock: hasAvailabilityCheck(state.storeSelectorAvailability.availability),
    apiSearchValue: state.storeSelectorTracking.apiSearchValue
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAvailability: function getAvailability(url, data) {
      dispatch(getAvailabilityAction(url, data));
    },
    getMoreAvailability: function getMoreAvailability(url, data) {
      dispatch(getMoreAvailabilityAction(url, data));
    },
    initTracking: function initTracking(config, stockFinderEnabled, activeFilter, skuQty) {
      dispatch(initTrackingAction(config, stockFinderEnabled, activeFilter, skuQty));
    },
    trackQuit: function trackQuit() {
      dispatch(clickQuitAction());
    },
    trackMap: function trackMap(storeId) {
      dispatch(clickStoreDetailsAction(storeId));
    },
    trackSelectStore: function trackSelectStore(storeId, ctaLocation) {
      dispatch(clickSelectStoreAction(storeId, ctaLocation));
    },
    trackWantItDelivered: function trackWantItDelivered() {
      dispatch(clickWantItDeliveredAction());
    },
    trackFilter: function trackFilter(filter) {
      dispatch(clickFilterAction(filter));
    },
    trackSearch: function trackSearch(searchTerm, updateState, searchBoxWasUsed) {
      dispatch(trackSearchAction(searchTerm, updateState, searchBoxWasUsed));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreSelector);
export { StoreSelector };